import React from 'react';
import { Inventory } from './inventory';
import './App.css';

function App() {
  return (
    <div className="App">
      <Inventory />
    </div>
  );
}

export default App;
